import React, { useContext, useEffect, useState, useRef } from 'react';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../pages/users/TableIcons';
import app from '../../../authentication/firebaseStart';
import { AuthContext } from '../../../authentication/Auth';
import Pagination from '../../../pages/users/components/Pagination';
import ApsToolbar from '../../../pages/users/components/ApsToolbar';
import styled from "styled-components";
import DropdownCustom from '../../../components/DropdownCustom';
import GoBack from '../../../components/GoBack';
import { useTranslation } from "react-i18next";
import { Tooltip } from '@material-ui/core';
import DropdownActions from '../../../components/DropdownSimple';
import DevicesManageAMDModal from '../../../components/modals/DevicesManageAMDModal';
import CsvCompModal from '../../../components/modals/CsvCompModal';
import { AccessConfigData } from '../../../components/AccessCSVConfig';
import { DataContext } from '../../../data/DataContext';


import ActionDropDown from "../../../components/ActionDropDown";
import { AddAccessPointModal } from "../../../components/modals/AddAccessPointModal";
import Checkbox from '@material-ui/core/Checkbox';
import { APService } from '../../../Services/AccessPointService';
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import { SnackbarContent } from "../../../styled-components/shared";
import { Snackbar } from "@material-ui/core";
import BottomNavLinks from '../../../components/BottomNavLinks';
import { EditAccessPointModal } from "../../../components/modals/EditAccessPointModal";
import firebaseUtil from "../../../data/FirebaseUtil";
import { getURLFromGCSBucket } from "../../commonUtils/ExportUtils";
import AlertModal from '../../../components/modals/AlertModal';
import { userJustManager } from '../../../data/userUtil';

const CuzCell = styled.p`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;

const BacknTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
`;

const PageTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 27px;
  margin-bottom: 5px;
  color: #007ABA;
  width: 100%;
  @media screen and (max-width: 700px){
    flex-direction: column;
  }
`
const TitleNDropdown = styled.span`
  margin-left: 20px;
`

const MainContent = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
  @media screen and (max-width: 750px) {
    margin-top: 35px;
  }
`;

const PageWrapper = styled.div`
    background: white;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 20%);
    padding: 20px;
`;

const DropDownWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // flex-direction: column;
    label{
      font-weight: 500;
      margin: 0;
      // color: #1386c1;
      font-size: 15px;
    }
`;

const SiteData = styled.div`
    display: flex;
    margin-bottom: 8px;
`;

const SiteNameLabel = styled.div`
  font-weight: 500;
  ${'' /* width: 1000px; */}
`;

const StyledTextField = styled.div`
  margin-left: 10px;
`;

const firestore = app.firestore();
var allApsData = [];

var allApsData = [];
const imgStyleLoader = {
  width: 18,
  height: 18,
  marginTop: 6,
  marginLeft: -15,
  marginRight: 5,
}

function BasicSorting() {
  //Loader
  const [isLoading, setIsLoading] = useState(false);
  const context = useContext(AuthContext);

  const isManager = userJustManager(context.currentUser.claims);
  let siteNameAssigned=""
  if(isManager){
    siteNameAssigned = context.currentUser.claims.siteArr[0].toUpperCase();
  } 

  //pagination
  const [TotalData, setTotalData] = useState(0)
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  //Data
  const [ApsData, setApsData] = useState([])
  const DEFAULT_SITE = isManager ?
  {label: siteNameAssigned, value: siteNameAssigned} : { label: "All Sites", value: "All Sites" };
  const [initSiteData, setInitSiteData] = useState([DEFAULT_SITE]);
  const [siteDatas, setsiteData] = useState();
  const companyID = context.currentUser.claims.companyID;
  const { t } = useTranslation();
  let { globalAppSettings } = useContext(DataContext);

  //Filter
  const [APS_SITE_FILTER, set_APS_SITE_FILTER] = useState(DEFAULT_SITE)
  const [APS_ACCESS_FILTER, set_APS_ACCESS_FILTER] = useState('')
  const [APS_SEARCH_FILTER, set_APS_SEARCH_FILTER] = useState(['', ''])
  const [manageBtnValue, setManageBtnValue] = useState({})
  const DevicesManageAMDModalRef = useRef();
  const CsvCompModalRef = useRef();
  const AddDevicesModalRef = useRef();
  const [sitesData, setSitesData] = useState([])
  const [enableModDelete, setEnableModDelete] = useState(false)
  const [hasUpdatedTime, setHasUpdatedTime] = useState(false)
  const [isLoadingCsv, setIsLoadingCsv] = useState(false)

  const addAPModalRef = useRef();

  //Selected items
  const [selectedData, setSelectedData] = useState([]);
  const [selectAll, setselectAll] = useState(false)
  //const [dbSearch, setdbSearch] = useState(['', ''])
  const [data, setData] = useState([]);
  const [_ds, onRowSelected] = useState('')

  //Data used by confirmation popup
  const [confirmPopupData, setconfirmPopupData] = useState([]);
  const confirmationModalRef = useRef();
  const editModalRef = useRef();
  //const selectAllChecked = useRef(false);

  //Whether the EDIT dialog is for site/fields?
  const [editType, setEditType] = useState();

  const apsService = new APService();
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const snackBarContent = useRef();
  const isSnackbarFailure = useRef();
  const [apsCsvData, setApsCsvData] = useState([])
  const alertModalRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [searchField, setSearchField] = useState('');
  const [searchString, setSearchString] = useState('');

  useEffect(() => {
      const selectedSite = sessionStorage.getItem("selectedSite")
      if (selectedSite != null) {
        if (!isManager && (selectedSite === "All Devices" || selectedSite === "Unassigned Devices"
          || selectedSite === "ALL SITES")) {
          set_APS_SITE_FILTER(DEFAULT_SITE)
        } else {
          set_APS_SITE_FILTER({ label: selectedSite, value: selectedSite })
        }
      }
  }, [])

  const getAPSSearchData = (searchVal,opt)=>{
    setSearchString(searchVal);
    setSearchField(opt)
  }

  const onSelectAllChecked = () => {
    let rowData = []
    let data = ApsData;

    if (APS_SEARCH_FILTER[0] == "") {
      //No filter selected
      data.forEach(element => {

        let _data = { ...element, ...{ checked: !selectAll } }
        rowData.push(_data)
      });
    } else {
      //Filter sleted. So data will be in local. 
      //Filter only the current page
      for (let index = 0; index < pageSize; index++) {
        const element = data[(currentPage * pageSize) + index];
        if (element) {
          let _data = { ...element, ...{ checked: !selectAll } }
          rowData.push(_data)
        }
      }
    }
    let ddaa = []
    if (APS_SEARCH_FILTER[0] == "") {
      data.forEach(element => {

        let _data = { ...element, ...{ checked: !selectAll } }
        ddaa.push(_data)
        // element.checked = !selectAll
      });
    } else {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element) {
          let _data
          if (index >= currentPage * pageSize && index <= (((currentPage + 1) * pageSize) - 1)) {
            _data = { ...element, ...{ checked: !selectAll } }
          } else { _data = element }
          ddaa.push(_data)
        }
      }
    }

    setSelectedData(selectAll ? [] : rowData)
    setselectAll(!selectAll);
    setApsData(ddaa);
    onRowSelected(!_ds);
  }
  const updateSteInfo = async ()=>{
    await firestore
      .collection('tenants')
      .doc(companyID)
      .collection('Configuration')
      .doc('UpdatedTime')
      .set({
          siteInfoUpdated: Date.now()
        }, { merge: true })
  }

  useEffect(() => {
    getInitialSitesData();
    getAPSData();
    setSelectedData([]);
  }, [
    APS_SITE_FILTER,
    APS_ACCESS_FILTER,
    APS_SEARCH_FILTER,
    pageSize
  ])

  async function getAPSData(pageIncrement = 0) {
    try {
      setIsLoading(true);

      let QUERY = buildAPSQuery();
      let dataLimit = pageSize;
      /**
       * if current number is 1 and going to page zero by clicking on prev button
       * setting page inc to zero to fetch first page data
       */
      if(pageIncrement === -1 && currentPage === 1){
        pageIncrement = 0;
      }
      //TODO: This should be set to ideally count when the APs Count API is ready
      //For hard coded to 1000 to ensure the code is not having impacts even though it is not used.
      //Pagination number of pages are taken out from the UI until count API is available
      setTotalData(1000);
      setCurrentPage(pageIncrement == 0 ? 0 : currentPage + pageIncrement)

      if (APS_SEARCH_FILTER[0]) { dataLimit = 100 }
      else {
        if (pageIncrement != 0 && ApsData.length>0) {
          if (pageIncrement == 1) { QUERY = QUERY.startAfter(ApsData[ApsData.length - 1]?.apMacAddress).limit(dataLimit) }
          else if (pageIncrement == -1) { QUERY = QUERY.endBefore(ApsData[0]?.apMacAddress).limitToLast(dataLimit) }
        }
        else if( pageIncrement === 0 ){ QUERY = QUERY.limit(dataLimit) }
        else {
          /**
           * when page is changed and APs are empty then show empty for next pages
           */
          setApsData([]);
          setIsLoading(false)
          return;
        }
      }

      let apsData = (await QUERY.get()).docs.map((doc) => doc.data());

      setApsData(apsData)
      if (apsData.length > 0) {
        setEnableModDelete(true);
      } else {
        setEnableModDelete(false);
      }
      setIsLoading(false);
    } catch (err) { onError(err) }
  }

  let buildAPSQuery = () => {
    try {
      //Basic Query
      let query = firestore.collection('tenants').doc(companyID).collection('Aps');

      //Site Filter
      if ((APS_SITE_FILTER && APS_SITE_FILTER?.value != 'All Sites') || isManager) {
        query = query.where('siteName', '==', APS_SITE_FILTER?.value.toUpperCase())
      }

      // Filter DropDown Filter
      if (APS_ACCESS_FILTER) {
        if (APS_ACCESS_FILTER?.value == t('site.locationFriendlyName')) {
          query = query.where('apFriendlyName', '==', '')
        } else if (APS_ACCESS_FILTER?.value == 'Sites not assigned') {
          query = query.where('siteName', '==', '')
        }
      }

      //Search Text
      let SearchTxt = APS_SEARCH_FILTER[0].toUpperCase();
      let SearchField = APS_SEARCH_FILTER[1];
      if (SearchTxt) {
        if (SearchField == 'apMacAddress') {
          query = query.orderBy('apMacAddress').startAt(SearchTxt).endAt(SearchTxt + "\uf8ff")
        } else {
          query = query.orderBy(SearchField).orderBy('apMacAddress', 'desc').startAt(SearchTxt).endAt(SearchTxt + "\uf8ff")
        }
      } else {
        query = query.orderBy('apMacAddress', 'desc')
      }

      return query
    } catch (err) { onError(err) }
  }

  let changeOnFilter = (data, filter) => {
    try {
      if (filter == 'site') {
        let selectedSite = data?.target.value
        if (selectedSite === "All Sites") {
          selectedSite = "All Devices"
        }
        sessionStorage.setItem("selectedSite", selectedSite);
        if (APS_ACCESS_FILTER.value == 'Sites not assigned') { set_APS_ACCESS_FILTER(''); }
        set_APS_SITE_FILTER(data?.target);
      }
      else if (filter == 'access') { set_APS_ACCESS_FILTER(data?.target) }
    } catch (err) { onError(err) }
  }

  function clearSelection() {

    //Cleawr the selected data
    setSelectedData([]);

    ApsData.forEach((row) => row.checked = false);

    setselectAll(false);
    //setApsData(ApsData);
  }

  let onPageChange = (direction) => {
    try {
      if (APS_SEARCH_FILTER[0]) { setCurrentPage(currentPage + direction) }
      else { getAPSData(direction) }
      clearSelection();
    } catch (err) { onError(err) }
  }


  let getInitialSitesData = async () => {
    console.log("initSiteData ",initSiteData)
    try {
      let fSiteData = []
      if(isManager){
        context.currentUser.claims.siteArr.forEach(el=>{
            fSiteData.push({ label: el, value: el });
          });
      }
      else {
        let siteData = (
          await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('SiteLocations')
            .orderBy('displaySiteName')
            .limit(10)
            .get()
        ).docs.map((doc) => doc.data());

        fSiteData = [DEFAULT_SITE];

        siteData.forEach(element => {
          fSiteData.push({ label: element.siteName, value: element.siteName })
        });
      }
      setInitSiteData(fSiteData)
      setsiteData(fSiteData)
    } catch (err) { onError(err) }
  }

  let getSelectInputSearch = async (rawInput, type) => {
    try {
      if (type === 'ENTERHIT' && rawInput) {
        let sites = [];
        setIsLoading(true);

        sites = (
          await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('SiteLocations')
            .orderBy('siteName')
            .startAt(rawInput.toUpperCase()).endAt(rawInput.toUpperCase() + "\uf8ff")
            .limit(10)
            .get()
        ).docs.map((doc) => doc.data());

        let finalSitesArray = [DEFAULT_SITE];
        if (sites.length > 0) {
          sites.forEach(element => {
            finalSitesArray.push({ label: element.siteName, value: element.siteName })
          });
        }
        setsiteData(finalSitesArray)
        setIsLoading(false);
        clearSelection();
      }
    } catch (err) { onError(err) }
  }

  const onError = (err) => {
    console.log(err);
    setIsLoading(false);
  }



  async function deleteAccessPoints(deleteAll) {

    //Deelete all the access points
    if (deleteAll) {
      // Delete all the items. If a filter isapplied, should delete only the filtered items
      //Use the current APS query which will dleete  the current selected
      //data based on search text & other parm
      await apsService.deleteAllAccessPoints(companyID, buildAPSQuery());
      //Refresh data. Before that clear the selection
      await updateSteInfo()
      clearSelection();
      getAPSData();
    }
    else {
      //Delete only seleted data..
      var itemsToDelete = selectedData;

      await apsService.deleteAccessPoints(companyID, itemsToDelete);
      await updateSteInfo()
      //Refresh data. Before that clear the selection
      clearSelection();
      getAPSData();
    }

  }


  async function showSnackBar(content, isFailure) {
    snackBarContent.current = content;
    isSnackbarFailure.current = isFailure;

    setIsSnackBarOpen(true);
  }


  async function handleConfirmationPopup(e) {

    //Hide the popup first and then proceed with delete
    confirmationModalRef.current.toggleDialog();

    if (e.btnData.scope == 'delete') {
      if (e.btnData.proceed) {
        //Delete action

        setIsLoading(true);

        await deleteAccessPoints(e.checkAll);
        setIsLoading(false);

        var msg = (e.checkAll) ? "All access points deleted" :
          selectedData.length + " access points deleted";

        showSnackBar(msg, false);
      }

    }
    else if (e.btnData.scope == 'modify') {
      if (e.btnData.proceed) {
        //Update action
        //Set all seected and call the dialog

        editModalRef.current.toggleDialog();

      }

    }
  }

  function onActionValueChanged(action) {

    if (action.key == "DELETE") {
      //Set the popup confirmation data. Popup will use this data

      let btnData = [
        { scope: 'delete', innerTxt: t('cancel'), proceed: false, class: '' },
        { scope: 'delete', innerTxt: t('confirm'), proceed: true, class: 'confirm' }
      ]

      //Set the data for showing popup
      setconfirmPopupData({
        title: t('delete'),
        btnData: btnData,
        msg: `${t('deviceDetail.message')}`,
        topMsg: `${selectedData.length} ${t('accessPoint.name')}${selectedData.length == 1 ? '' : 's'} ${t('deviceDetail.selected')}`,
        needcheck: selectAll,
        checktext: t("deleteAllRecordsConfirmMsg")
      });
      confirmationModalRef.current.toggleDialog();
    }
    else if (action.key == "UPDATE_SITE") {

      //sest the edit type
      setEditType("SITE");

      editModalRef.current.toggleDialog();
    }
    else if (action.key == "UPDATE_ITEM") {

      //Update for a signle item
      setEditType("ITEM");

      editModalRef.current.toggleDialog();
    }
  }

  function onChangeManageBtn(buttonValue, buttonName) {
    if (buttonValue === 'MODIFY' || buttonValue === 'DELETE') {
      CsvCompModalRef.current.toggleDialog();
      //getInitialSitesDataCsv()

    } else {
      DevicesManageAMDModalRef.current.toggleDialog();

    }
    setManageBtnValue({ name: buttonName, value: buttonValue, page: 'APS' })
  }

  function continueBtnClicked(value) {


    if (value.importMethod === "UPLOAD_CSV") {
      //getInitialSitesDataCsv();
      CsvCompModalRef.current.toggleDialog();
    }
    if (value.importMethod === "MANUAL") {
      addAPModalRef.current.toggleDialog();
    }

  }

  function refreshPageClicked() {
    getAPSData(0);
    setSelectedData([]);
  }

  var actionMenuOptions = [];

  if (!isManager) {
    //Modify site is applicable only for admin
    actionMenuOptions.push(
      {
        label: 'Modify Site', key: 'UPDATE_SITE',
        disable: false, action: 'd'
      }
    );
  }


  actionMenuOptions.push(
    //Modify Details should be allowed only for 1 item
    {
      label: t('csvModal.ModifyDetails'), key: 'UPDATE_ITEM',
      disable: (selectedData.length > 1) ||
        (isManager ? (globalAppSettings?.userRoleSettings?.manager?.Aps && globalAppSettings?.userRoleSettings?.manager?.Aps[0] === 'write' ? false : true) : !enableModDelete)
      , action: 'd'
    });

  //09/05: Fix to show DELETE for managers also. removed that condition
  actionMenuOptions.push(
    //Modify Details should be allowed only for 1 item
    {
      label: t('csvModal.Delete'), key: 'DELETE',
      disable:
        (
          isManager ?
            globalAppSettings?.userRoleSettings?.manager?.Aps && globalAppSettings?.userRoleSettings?.manager?.Aps[0] === 'write' ? false : true : !enableModDelete
        ),
      action: 'd'
    }
  );


  //Menus
  var menus = [];

  if (!isManager) {
    //Add site is available only for ADMIN
    // menus.push({ name: 'Add', value: 'ADD', active: false });
    menus.push({ name: t('csvModal.Add'), value: 'ADD', active: false });
    menus.push({ name: t('csvModal.Modify'), value: 'MODIFY', active: !enableModDelete });
    menus.push({ name: t('csvModal.Delete'), value: 'DELETE', active: !enableModDelete });

  }
  let managerAccess = globalAppSettings?.userRoleSettings?.manager?.Aps

if ( isManager && managerAccess && managerAccess[0]) {
    menus.push( { name: t('csvModal.Add'), value: 'ADD', active: false});
    menus.push( { name: t('csvModal.Modify'), value: 'MODIFY', active: !enableModDelete } );
    menus.push({ name: t('csvModal.Delete'), value: 'DELETE', active: !enableModDelete } );
  }

  function onCancelHit() {
    allApsData = [];
  }

  const [exportBtnState, setexportBtnState] = useState('none')

  async function exportcsv() {
    if(ApsData && ApsData.length > 0) {
      let data = {
        "entityType": "aps",
        "site": APS_SITE_FILTER.value,
        "searchField": searchField,
        "searchText": searchString,
        "apsFilter":APS_ACCESS_FILTER.value ? APS_ACCESS_FILTER.value:""
      }
      setexportBtnState('exporting')
      let response = await firebaseUtil.exportConfiguration(data, t);
      console.log(response.msg, 'response.msg');
    
      if (response?.status) {
        let url = response.msg.filePath;
        let jobId = response.msg.jobId;
        const ref = firestore.collection('tenants').doc(companyID).collection('Jobs').doc(jobId);
        ref.onSnapshot((querySnapshot) => {
          let items = querySnapshot.data();
          if (items.status === 2) {
            async function getURL() {
              setexportBtnState('down')
              let result = await getURLFromGCSBucket(url, companyID, 'aps');
              setexportBtnState('none')
            }
            getURL();

          }
        })
      }
      else {
        setexportBtnState('none');
        showSnackBar(t('error'), true);
      }
    } else {
      setErrorMessage('Export cannot be performed for empty records');
      alertModalRef.current.open();
    }

  }

  return (
    <PageWrapper style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
      <div style={{ display: 'flex', alignItem: 'center', justifyContent: 'space-between' }}>
        <BacknTitle>
          <GoBack />
          <TitleNDropdown>
            <PageTitle>{t('AccessPoints')}</PageTitle>
            {
                <DropdownCustom
                  selectOpts={siteDatas}
                  onChange={(e) => changeOnFilter(e, 'site')}
                  resetSelect={false}
                  selectVal={APS_SITE_FILTER.label ? APS_SITE_FILTER : DEFAULT_SITE}
                  isSearchable={true}
                  onSearchInpChange={getSelectInputSearch}
                  isLoading={isLoading}
                  customFilterOption={() => { return siteDatas }}
                  selectOnBlur={() => { }}
                // selectXbtnClicked
                />
            }

          </TitleNDropdown>

        </BacknTitle>



        <button
          id="download-data"
          style={{
            padding: '10px 20px',
            backgroundColor:
              exportBtnState == 'none' ? '#007ABA' :
                exportBtnState == 'exporting' ? '#ffc107' :
                  exportBtnState == 'down' ? '#8bc34a' : '#007ABA',
            borderRadius: 4,
            fontFamily: "Segoe UI",
            border: '1px solid ',
            position: 'inline',
            color: ' #fff',
            fontWeight: 500,
            fontSize: '15px',
            cursor: exportBtnState == 'none' ? 'pointer' : 'not-allowed',
            height: 'fit-content',
            margin: 'auto 0',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={exportcsv}
        >
          {exportBtnState != 'none' ?
            <img src={process.env.PUBLIC_URL + '/csv_export.gif'} style={imgStyleLoader} /> : ""}
          {`${exportBtnState == 'none' ? t('exportingData') :
            exportBtnState == 'exporting' ? t('exporting') :
              exportBtnState == 'down' ? t('downloading') : null}`}
        </button>
      </div>
      <DropDownWrapper>
        <DropDownWrapper>
          <label>{t('filter')} :</label>
          {
            isManager ?
              <DropdownCustom
                selectOpts={[
                  { label: t('none'), value: t('none') },
                  {
                    label: t('site.locationFriendlyName'),
                    value: t('site.locationFriendlyName'),
                    isDisabled: APS_SEARCH_FILTER && APS_SEARCH_FILTER[1].trim() === 'apFriendlyName'
                  },
                ]}
                onChange={(e) => changeOnFilter(e, 'access')}
                resetSelect={false}
                selectVal={APS_ACCESS_FILTER ? APS_ACCESS_FILTER : { label: t('none'), value: t('none')}}
                isSearchable={false} />
              :
              <DropdownCustom
                selectOpts={[
                  {
                    label: t('none'),
                    value: t('none')
                  },
                  {
                    label: t('site.notAssigned'),
                    value: t('site.notAssigned'),
                    isDisabled: APS_SITE_FILTER && APS_SITE_FILTER.value !== 'All Sites' ? true : false
                  },
                  {
                    label: t('site.locationFriendlyName'),
                    value: t('site.locationFriendlyName'),
                    isDisabled: APS_SEARCH_FILTER && APS_SEARCH_FILTER[1].trim() === 'apFriendlyName'
                  },
                ]}
                onChange={(e) => changeOnFilter(e, 'access')}
                resetSelect={false}
                selectVal={APS_ACCESS_FILTER ? APS_ACCESS_FILTER : { label: t('none'), value: t('none') }}
                isSearchable={false} />
          }
        </DropDownWrapper>


        <DropDownWrapper>
          {
            (isManager &&
              globalAppSettings?.userRoleSettings?.manager?.Devices && globalAppSettings?.userRoleSettings?.manager?.Aps && globalAppSettings?.userRoleSettings?.manager?.Aps[0] === 'write') || !isManager ?

              <DropdownActions
                styleClassName={'manageDropAccess'}
                label={t('csvModal.Manage')}
                opts={
                  menus

                }
                onChangeAction={onChangeManageBtn}
              /> : null}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ActionDropDown
              label={t('action')}
              disable={false}
              selectedRows={selectedData.length}
              options={actionMenuOptions}
              GetChangeAction={onActionValueChanged}
              clrSelectedRows={() => {

                setselectAll(!selectAll);
                clearSelection();
                onRowSelected(!_ds);
              }}
            />

          </div>
        </DropDownWrapper>
      </DropDownWrapper>
      <br />

      <MainContent>
        <MaterialTable
          title="Basic Sorting Preview"
          isLoading={isLoading}
          columns={[
            {
              title: (<Checkbox
                //05/02: Fix for selection in the last page. Check PageSie/Current ApS data.length
                checked={pageSize && ApsData && ApsData.length != 0 && ((pageSize == selectedData.length) || (ApsData.length == selectedData.length))}
                onChange={(e) => {
                  onSelectAllChecked();
                }
                }

                color="primary"
                name="deviceRow" />),
              field: "friendlyName",
              cellStyle: {
                minWidth: 70,
                maxWidth: 70,
              },
              render: rowData => {
                return (


                  <Checkbox
                    checked={rowData?.checked ? true : false}
                    onChange={(e) => {
                      let selectedItems = selectedData;
                      rowData.checked = e.target.checked;

                      if (e.target.checked) {
                        //item seleted
                        //Add to the selected data
                        selectedItems.push(rowData);

                      }
                      else {
                        //delete the item from selected
                        const item = selectedItems.filter((x) => x.apMacAddress == rowData.apMacAddress)

                        let rowIndex = selectedItems.indexOf(item);

                        selectedItems.splice(rowIndex, 1);
                        rowData.checked = false;
                        setselectAll(false)
                      }

                      setSelectedData(selectedItems);
                      //To refresh the UI, just call this
                      onRowSelected(!_ds);
                    }
                    }

                    value={rowData.checked}

                    color="primary"
                    name="deviceRow" />

                )
              }
            },
            {
              title: 'Site Name',
              field: 'siteName',
              render: rowData => {
                return (<span>
                  {rowData?.siteName?.length > 10 ?
                    <Tooltip title={rowData.siteName} arrow placement="bottom-start">
                      <CuzCell>{rowData.siteName}</CuzCell>
                    </Tooltip>
                    :
                    <CuzCell>{rowData.siteName}</CuzCell>
                  }
                </span>
                )
              }
            },
            { title: 'MAC Address', field: 'apMacAddress' },
            {
              title: 'Location Friendly Name', field: 'apFriendlyName',
              render: rowData => {
                return (<span>
                  {rowData?.apFriendlyName?.length > 10 ?
                    <Tooltip title={rowData.apFriendlyName} arrow placement="bottom-start">
                      <CuzCell>{rowData.apFriendlyName}</CuzCell>
                    </Tooltip>
                    :
                    <CuzCell>{rowData.apFriendlyName}</CuzCell>
                  }
                </span>
                )
              }
            },
          ]}
          data={ApsData}
          options={{
            // actionsColumnIndex: 2,
            paginationType: 'stepped',
            search: true,
            minBodyHeight: '250px',
            maxBodyHeight: '469px',
            sorting: false,
            // selection: true,
            paging: TotalData > pageSize ? true : false,
            pageSize: pageSize,
            cspNonce: window.NONCE_ID
          }}
          icons={tableIcons}
          onChangeRowsPerPage={(val) => {
            setPageSize(val);
          }}
          components={{
            Pagination: (props) => (
              <Pagination
                {...props}
                itemCount={TotalData}
                currentPage={currentPage}
                onNextClicked={() => { onPageChange(1) }}
                onPrevClicked={() => { onPageChange(-1) }}
              />
            ),
            Toolbar: (props) => (
              <ApsToolbar
                titleProp={'Access Point Details'}
                inputSearchPlaceholder={'Enter a access point name'}
                searchText={APS_SEARCH_FILTER[0]}

                onSearch={(searchVal, searchOptVal) => {
                  set_APS_SEARCH_FILTER([searchVal, searchOptVal]);
                  getAPSSearchData(searchVal,searchOptVal);
                  //Finally clear the selected data
                  setSelectedData([]);
                }}

                multiSearchOpts={[{
                  name: 'MAC Address',
                  value: 'apMacAddress',
                  disable: false
                },
                {
                  name: 'Location',
                  value: 'apFriendlyName',
                  disable: APS_ACCESS_FILTER.value == t('site.locationFriendlyName')
                }]}
                onClear={(searchVal) => {
                  set_APS_SEARCH_FILTER(['', '']);
                  getAPSSearchData('','');
                  clearSelection();
                }}
                onRefreshClick={() => refreshPageClicked()}

              />
            ),

          }}
        />
      </MainContent>

      <div>
        <Snackbar
          open={isSnackBarOpen}
          autoHideDuration={5000}
          onClose={() => {
            setIsSnackBarOpen(false);
          }
          }
        >
          <SnackbarContent error={isSnackbarFailure.current ? true : false}>
            {snackBarContent.current}
          </SnackbarContent>
        </Snackbar>
      </div>

      <AlertModal 
        modalRef={alertModalRef} 
        message={errorMessage} />

      <DevicesManageAMDModal
        modalRef={DevicesManageAMDModalRef}
        importType={manageBtnValue}
        onContinue={continueBtnClicked}
        isLoadingCsv={isLoadingCsv}
      />
      <CsvCompModal
        modalRef={CsvCompModalRef}
        importType={manageBtnValue}
        ConfigData={AccessConfigData}
        //sitesData={sitesData}
        //apsData={apsCsvData}
        refreshPage={refreshPageClicked}
        //hasUpdatedTime={hasUpdatedTime}
        //isLoadingCsv={isLoadingCsv}
        onCancelHit={onCancelHit}
      />
      <ConfirmationModal
        title={confirmPopupData.title}
        body={confirmPopupData.msg}
        modalRef={confirmationModalRef}
        btnData={confirmPopupData.btnData}
        topMsg={confirmPopupData.topMsg}
        needcheck={confirmPopupData.needcheck}
        checktext={confirmPopupData.checktext}
        id={'ConfirmationModal'}
        fromConfirmationPopup={handleConfirmationPopup}
      />

      <AddAccessPointModal
        isManager={isManager}
        modalRef={addAPModalRef}
        assignedSite={siteNameAssigned}
        onAccessPointAdded={
          async () => {
            //When the AP is added, just refresh the screen
            clearSelection();

            //Show the status
            var msg = t("accessPoint.apAddedMsg");

            showSnackBar(msg, false);
            await updateSteInfo()
            await getAPSData();
          }
        }
        tenantId={companyID}
      />

      <EditAccessPointModal
        isManager={isManager}
        allItemsSelected={selectAll}
        modalRef={editModalRef}
        assignedSite={siteNameAssigned}
        selectedItems={selectedData}
        query={buildAPSQuery()}
        editType={editType}
        id={'EditAccessPointModal'}
        onAccessPointUpdated={
          async (allSitesModified) => {
            //When the AP is added, just refresh the screen
            //Clear the selection
            clearSelection();

            //Show the status
            var msg = (allSitesModified) ? "All access points updated" :
              selectedData.length + " access points updated";
            await updateSteInfo()
            showSnackBar(msg, false);
            await getAPSData();
          }
        }
        tenantId={companyID}
      />
      <BottomNavLinks />
    </PageWrapper>
  )
}

export default BasicSorting;